import posthog from 'posthog-js';

import { CAST_AI } from '@cast/constants';
import { Box, Button, Icons, MarketingBanner } from '@cast/design-system';
import { MCPBanner } from 'assets/svg';
import { getDocsLink } from '@cast/utils';

export const CAST_MCP_BANNER_ID = 'cast-mcp-banner';

export const CastMCPBanner = ({ onClose }: { onClose: () => void }) => {
  return (
    <MarketingBanner
      testId={CAST_MCP_BANNER_ID}
      title={`Connect AI tools to ${CAST_AI} MCP`}
      message={`Connect your AI tools to ${CAST_AI} MCP to ask questions about your clusters, costs, efficiency, and health.`}
      endContent={
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          height="100%"
        >
          <MCPBanner />
        </Box>
      }
      action={
        <Button
          size="sm"
          endIcon={<Icons.ArrowSquareIn />}
          component="a"
          href={getDocsLink('docs_cast_mcp')}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            posthog.capture('user-wants-mcp');
          }}
        >
          View setup guide
        </Button>
      }
      onClose={onClose}
    />
  );
};
